// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'countryside-mainpage-frontend';

export const DEFAULT_CIAN_DOMAIN = 'cian.ru';
